import { createAction, props } from '@ngrx/store';

export const openChatPanel = createAction(
  '[AI Chat] Open Chat Panel',
  props<{ projectId: string }>(),
);

export const chatPanelOpened = createAction(
  '[AI Chat] Open Chat Panel opened',
  props<{ projectId: string }>(),
);
